<template>
  <div class="layout">
    <VHeader class="tabBar" />
    <div class="layout_item">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import VHeader from "@/components/header/index.vue";
import utils from "@/utils";
// import { getMessageList } from "@/api";
export default {
  data() {
    return {};
  },
  methods: {
    initMessage() {
      let data = {
        pageNum: 1,
        pageSize: 5,
        userId: utils.getStore("user_id"),
      };
      // getMessageList(data).then((res) => {
      //   if (res.success) {
      //     this.list_data = res.result.data.records;
      //     //设置导航的消息未读状态
      //     let isRead = res.result.unReadNumber;
      //     this.$store.dispatch("setMsgRead", isRead);
      //   }
      // });
    },
  },
  mounted() {
    this.initMessage();
  },
  components: {
    VHeader,
  },
};
</script>

<style lang="scss" scoped>
.layout {
  height: 100%;
  display: flex;
  min-width: 1200px;
  flex-direction: column;
  .tabBar {
    flex-shrink: 0;
  }
  .layout_item {
    flex: 1;
  }
}
</style>
